export default {
  traveller: {
    default: 'Voyageur | Voyageurs',
    defaults: 'Voyageurs',
    list: {
      page_title: 'Liste des voyageurs'
    },
    find: 'Saisir au moins 3 lettres',
    list_title: 'Mes voyageurs',
    enabled_travellers: 'Actifs',
    disabled_travellers: 'Désactivés',
    all: 'Tous',
    per_text: 'Par prénom, nom, email',
    per_status: 'Par état',
    no_custom_fields: 'Pas de champs personnalisés',
    unknown: 'Voyageur inconnu',
    no_travellers: 'Aucun voyageur',
    references: 'Références voyageur',
    add: {
      title: "Ajout d'un voyageur",
      alert: {
        success: 'Le voyageur a bien été créé',
        failure: "Une erreur est survenue. Le voyageur n'a pas été créé"
      },
      existing: 'Champs existant(s)'
    },
    edit: {
      title: "Edition d'un voyageur",
      alert: {
        success: 'Le voyageur a bien été modifié',
        failure: "Une erreur est survenue. Le voyageur n'a pas été modifié"
      }
    },
    no_result: 'Aucun voyageur ne correspond à votre recherche.',
    import: {
      title: 'Importer des voyageurs',
      text: 'Seuls les voyageurs non existants seront importés.',
      allowedExtensions: 'Formats acceptés : {formats}.',
      dlExample: 'Télécharger un modèle',
      alert: {
        success: '{nb} voyageur importé | {nb} voyageurs importés',
        edit: '{nb} voyageur édité | {nb} voyageurs édités',
        warning: 'Lignes non traitées :'
      }
    },
    fields: {
      firstname: 'Prénom',
      lastname: 'Nom',
      phone: 'Téléphone',
      email: 'Email'
    }
  }
}
